import { useCallback, useEffect, useState } from 'react';

export function useReviewCarousel(count: number, intervalMs = 6000) {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState<1 | -1>(1);
  const [paused, setPaused] = useState(false);

  const go = useCallback(
    (next: number, dir: 1 | -1) => {
      if (count === 0) return;
      setDirection(dir);
      setIndex(((next % count) + count) % count);
    },
    [count]
  );

  const next = useCallback(() => go(index + 1, 1), [go, index]);
  const prev = useCallback(() => go(index - 1, -1), [go, index]);
  const goTo = useCallback((i: number) => go(i, i >= index ? 1 : -1), [go, index]);

  useEffect(() => {
    if (paused || count < 2) return;
    const timer = window.setTimeout(next, intervalMs);
    return () => window.clearTimeout(timer);
  }, [paused, count, next, intervalMs, index]);

  return { index, direction, next, prev, goTo, setPaused };
}
